import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiClient } from '../services/api-client';
import { AuthStore } from './auth-store';
import { JwtDecoderService } from '@core/services/jwt-decoder-service';

export const authGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const apiClient = inject(ApiClient);
  const authStore = inject(AuthStore);
  const jwtDecoder = inject(JwtDecoderService);

  const isRootRoute = route.routeConfig?.path === '' && state.url === '/';
  const accessToken = authStore.getAccessToken();

  if (!accessToken) {
    try {
      const newToken = await apiClient.refreshAccessToken();
      if (newToken) {
        authStore.setAccessToken(newToken);

        if (isRootRoute) {
          if (jwtDecoder.getUserRole(newToken) == 'admin') {
            router.navigate(['/users']);
          } else {
            router.navigate(['/candidates']);
          }
          return false;
        }
        return true;
      }
    } catch {
      if (state.url !== '/login') {
        router.navigate(['/login']);
      }
      return false;
    }
  } else {
    try {
      await apiClient.verifyAccessToken(accessToken);

      if (isRootRoute) {
        if (jwtDecoder.getUserRole(accessToken) == 'admin') {
          router.navigate(['/users']);
        } else {
          router.navigate(['/candidates']);
        }
        return false;
      }
      return true;
    } catch {
      try {
        const newToken = await apiClient.refreshAccessToken();
        if (newToken) {
          authStore.setAccessToken(newToken);

          if (isRootRoute) {
            if (jwtDecoder.getUserRole(newToken) == 'admin') {
              router.navigate(['/users']);
            } else {
              router.navigate(['/candidates']);
            }
            return false;
          }
          return true;
        } else {
          if (state.url !== '/login') {
            router.navigate(['/login']);
          }
          return false;
        }
      } catch {
        if (state.url !== '/login') {
          router.navigate(['/login']);
        }
        return false;
      }
    }
  }

  if (state.url !== '/login') {
    router.navigate(['/login']);
  }
  return false;
};
